import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getIssuesEntities from '../../services/issuesEntities/getIssuesEntities'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchIssuesEntity () {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const issuesEntities = yield call(getIssuesEntities, auth.token)
    yield put(fetchCombosSuccess({ issuesEntities }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchIssuesEntity () {
  yield takeLatest(combosActionTypes.FETCH_ISSUE_ENTITY, fetchIssuesEntity)
}
